module.exports = __webpack_public_path__ + "img/info.fd3c37bf.svg";